import { INBOX_TYPES, TWILIO_CHANNEL_MEDIUM } from 'dashboard/helper/inbox';
import {
  CATALOG_CARD_GRADIENT_CLASSES,
  CATALOG_CARD_GRADIENT_FALLBACK_CLASS,
} from 'dashboard/helper/channelCatalogGradientClasses';

/**
 * Maps an inbox to the same catalog key used by ChannelCatalogCard gradients.
 * @param {{ channel_type?: string, medium?: string, provider?: string }} inbox
 * @returns {string|null}
 */
export function getCatalogCardKeyForInbox(inbox) {
  if (!inbox?.channel_type) return null;
  const { channel_type: type, medium, provider } = inbox;

  switch (type) {
    case INBOX_TYPES.FB:
      return 'facebook';
    case INBOX_TYPES.WEB:
      return 'website';
    case INBOX_TYPES.WHATSAPP:
      return 'whatsapp';
    case INBOX_TYPES.WHATSAPP_BROWSER:
      return 'whatsapp_browser';
    case INBOX_TYPES.API:
      if (provider === 'waha_browser_whatsapp') return 'whatsapp_browser';
      return 'api';
    case INBOX_TYPES.EMAIL:
      return 'email';
    case INBOX_TYPES.TWILIO:
      if (medium === TWILIO_CHANNEL_MEDIUM.WHATSAPP) return 'whatsapp';
      return 'sms';
    case INBOX_TYPES.SMS:
      return 'sms';
    case INBOX_TYPES.TELEGRAM:
      return 'telegram';
    case INBOX_TYPES.LINE:
      return 'line';
    case INBOX_TYPES.INSTAGRAM:
      return 'instagram';
    case INBOX_TYPES.TIKTOK:
      return 'tiktok';
    case INBOX_TYPES.VOICE:
      return 'voice';
    default:
      return null;
  }
}

/**
 * @param {{ channel_type?: string, medium?: string, provider?: string }} inbox
 * @returns {string}
 */
export function getCatalogCardGradientClassForInbox(inbox) {
  const key = getCatalogCardKeyForInbox(inbox);
  return (
    (key && CATALOG_CARD_GRADIENT_CLASSES[key]) ||
    CATALOG_CARD_GRADIENT_FALLBACK_CLASS
  );
}
